var _defs, _path, _path2, _polyline;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapNumbering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        stroke-width: 1.3px;\n      }\n\n      .b, .c {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .c {\n        stroke-width: 1.52px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.21,18.38c.78-.15,2.21-.4,2.53-1.47.23-.76.24-1.56.22-2.35-.04-1.73-.09-3.48-.54-5.15-.22-.81-.54-1.61-1.04-2.29-.26-.36-.57-.68-.93-.94-.41-.3-.99-.47-1.08-.58.04-.1.91-3.1,5.18-4.13,7.59-1.82,10.47,3.65,9.35,9.15-.11.56-.27,1.16-.48,1.79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M5.98,16.27s7.3-3.79,11.08-3.89"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "8.73 6.79 10.77 4.76 10.77 4.92 10.77 11.05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapNumbering);
export default __webpack_public_path__ + "static/media/cap-numbering.345e9ad7edf2ea0367a0829af35ebf72.svg";
export { ForwardRef as ReactComponent };